module.exports = __webpack_public_path__ + "static/media/couches.30cece15.jpg";